import { Paper as MantinePaper, PaperProps } from '@mantine/core';

export type IPaperProps = PaperProps;

/** @registry Design-layer pass-through over Mantine Paper; import this instead of @mantine/core Paper outside src/design. */
export const Paper = MantinePaper;
